import { useState, useEffect } from 'react';
import { useTheme } from '../../context/ThemeContext';

export default function ScrollToTop() {
  const [visible, setVisible] = useState(false);
  const { isDark } = useTheme();

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 320);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const scrollTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });

  return (
    <button
      onClick={scrollTop}
      title="Volver arriba"
      aria-label="Volver al inicio de la página"
      className={`fixed bottom-24 right-3 sm:bottom-28 sm:right-6 z-50 w-10 h-10 sm:w-11 sm:h-11 flex items-center justify-center rounded-xl border transition-all duration-300 cursor-pointer ${
        visible ? 'opacity-100 translate-y-0 pointer-events-auto' : 'opacity-0 translate-y-4 pointer-events-none'
      } ${
        isDark
          ? 'bg-zinc-900 border-zinc-700 text-zinc-400 hover:border-red-600/60 hover:text-red-400 hover:bg-zinc-800'
          : 'bg-white border-zinc-200 text-zinc-500 hover:border-red-500/50 hover:text-red-500 hover:bg-zinc-50 shadow-sm'
      }`}
    >
      <i className="ri-arrow-up-line text-base" />
    </button>
  );
}
